import { render, staticRenderFns } from "./CertImagePicker.vue?vue&type=template&id=23f1120a&"
import script from "./CertImagePicker.vue?vue&type=script&lang=js&"
export * from "./CertImagePicker.vue?vue&type=script&lang=js&"
import style0 from "./CertImagePicker.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports